<script lang="ts">
  import ArrowLink from "$lib/atoms/ArrowLink.svelte";
  import Icon from "$lib/atoms/Icon.svelte";
  import { IconType } from "$types/atoms";
  import { parseUrl } from "$lib/utils/helpers";
  import { slide } from "svelte/transition";
  import { quintOut } from "svelte/easing";
  import resizeImage from "$lib/utils/resizeImage";
  import { aspectRatio } from "$lib/utils/optimizeImage";
  export let post: any;

  // let isExternalLink = post?.content?.externalLink?.url?.length > 0;
  const providers = post.content?.podcastFields?.providers;

  $: dialogOpen = false;
</script>

<!-- href={post?.content?.externalLink?.url || '/' + parseUrl(post.full_slug)} -->
<!-- target={isExternalLink ? '_blank' : ''} -->
<!-- rel={isExternalLink ? 'noopener noreferrer' : ''} -->
<div
  class="bg-sand h-full flex flex-col rounded-[6px] overflow-hidden no-underline p-[1rem]"
>
  <div
    class="relative shrink-0 aspect-1 overflow-hidden rounded-[7px] bg-[rgb(var(--color-light-grey))]"
  >
    {#if post?.content?.mastheadImage.filename}
      <img
        src={resizeImage(post.content.mastheadImage.filename, 702, 702)}
        alt={post?.content?.mastheadImage.alt}
        class="object-cover object-center w-full h-full"
        style={aspectRatio(post.content.mastheadImage.filename)}
        loading="lazy"
      />
    {/if}
    <div
      class="absolute top-[12px] left-[12px] type:label p-[9px] sm:p-[12px] leading-[1] rounded-[2px] bg-white flex items-center gap-[0.75rem] text-black !text-[14px] md:!text-[17px] lg:!text-[19px]"
    >
      <Icon type={IconType.PODCAST} />
      {post?.content?.mediaLength}
    </div>
  </div>

  <div
    class="px-[19px] py-[24px] flex-1 flex flex-col gap-[2rem] justify-between"
  >
    <div>
      {#if post?.topic || post?.category_name}
        <p class="uppercase type:h5-eyebrow text-black/50">
          {@html post?.topic || post?.category_name}
        </p>
      {/if}
      <h2 class="mt-[1rem] type:h6-medium text-charcoal line-clamp-2">
        {@html post?.content?.previewHeading || post?.name}
      </h2>
      {#if post?.content?.author?.length > 0}
        <p class="mt-[1.5rem] type:body-medium text-black/50">
          Hosted by {post?.content?.author}
        </p>
      {/if}
    </div>

    {#if providers.length > 0}
      <div class="relative type:h6-small">
        <div
          class="flex items-center bg-white pl-[27px] pr-[12px] py-[1rem] rounded-[2px] overflow-hidden cursor-pointer group"
          role="button"
          tabindex="0"
          on:keyup={() => {}}
          on:click={() => {
            dialogOpen = !dialogOpen;
          }}
        >
          <div class="flex-auto">Listen now</div>
          <svg
            class="w-[26px] h-auto transform {dialogOpen ? 'rotate-180' : ''}"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              class="fill-[#F2F1EF] transition duration-200 group-hover:fill-[rgb(var(--color-red-secondary))]"
              cx="13"
              cy="13"
              r="13"
            />
            <path
              class="stroke-[#4B4B4B] transition duration-200 group-hover:stroke-[#fff]"
              d="M18 12l-5 5-5-5"
              stroke-width="1.5"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        {#if dialogOpen}
          <div
            transition:slide|global={{
              duration: 300,
              easing: quintOut,
              axis: "x",
            }}
            class="absolute bottom-[100%] inset-x-0"
          >
            <div
              class="py-1 px-[19px] mb-1 bg-white rounded-[var(--border-radius-small)] overflow-hidden"
            >
              <div>
                {#each providers as p, i}
                  <a
                    href={p.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    class="group py-[17px] flex items-center gap-x-[1rem] no-underline text-inherit hover:underline"
                    style="border-top:{i !== 0
                      ? '1px solid rgba(0,0,0,0.1)'
                      : ''}"
                  >
                    <div class="flex-[0_0_26px]">
                      <div class="rounded-[50%] aspect-square">
                        {#if p.type === "Apple Podcasts"}
                          <img
                            class="w-full h-full"
                            src="/images/podcast-providers/apple-music.webp"
                            alt="Apple Podcasts"
                          />
                        {/if}
                        {#if p.type === "Spotify"}
                          <img
                            class="w-full h-full"
                            src="/images/podcast-providers/spotify.webp"
                            alt="Spotify"
                          />
                        {/if}
                      </div>
                    </div>
                    <div class="relative top-[1px]">{p.type}</div>
                  </a>
                {/each}
              </div>
            </div>
          </div>
        {/if}
      </div>
    {/if}
  </div>
</div>
